'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeFeatureInCatalogClickEvent = composeFeatureInCatalogClickEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;
var CONTENT_TYPES = CUSTOM_DIMENSIONS.CONTENT_TYPES;


function mapFicTypeToContentType(type) {
  switch (type) {
    case 'RESOURCE':
      return CONTENT_TYPES.ONLINE_RESOURCE;
    case 'EVENT':
      return CONTENT_TYPES.EVENT;
    case 'BLOG_POST':
      return CONTENT_TYPES.BLOG;
    default:
      return null;
  }
}

function composeFeatureInCatalogClickEvent(_ref) {
  var text = _ref.text,
      url = _ref.url,
      type = _ref.type,
      payload = _objectWithoutProperties(_ref, ['text', 'url', 'type']);

  var gtmContentType = mapFicTypeToContentType(type);
  return (0, _compose.composeAnalytics)([(0, _compose.composeLinkEvent)(EVENTS.FEATURE_IN_CATALOG_CLICK, url, _extends({
    gtmCategory: CATEGORIES.FEATURE_IN_CATALOG,
    gtmLabel: text,
    gtmValue: 1,
    gtmContentType: gtmContentType
  }, payload))]);
}

exports.default = {
  composeFeatureInCatalogClickEvent: composeFeatureInCatalogClickEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/featureInCatalogEventComposer.js
// module id = 580
// module chunks = 0 2 4 5 6 8 9 10 11